


















import { Component, Vue } from 'vue-property-decorator';
import { Config } from '@/utils/Config';
import { EventBus } from '@/utils/EventBus';
import MapLegend from '@/components/MapLegend.vue';
import '@/assets/alex.min';

@Component({
  components: {
    MapLegend
  }
})
export default class Map extends Vue {
  private isFullScreen: boolean = false;

  mounted() {
    EventBus.$on(Config.MapSetFullScreenEvent, this.setFullScreen);
  }

  beforeDestroy() {
    EventBus.$off(Config.MapSetFullScreenEvent, this.setFullScreen);
  }

  private setFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
  }
}
